import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../client';
import { qk } from './keys';
import type { City, Country, LocaleEntry, TriggerEventType } from '../types';

export function useCountries() {
  return useQuery({
    queryKey: qk.countries,
    queryFn: () => apiGet<Country[]>('/reference/countries'),
    staleTime: 5 * 60_000,
  });
}

export function useCities(countryCode: string | null, q?: string) {
  return useQuery({
    queryKey: qk.cities(countryCode ?? '', q),
    queryFn: () => {
      const qs = new URLSearchParams({ country_code: countryCode ?? '' });
      if (q) qs.set('q', q);
      return apiGet<City[]>(`/reference/cities?${qs.toString()}`);
    },
    enabled: !!countryCode,
  });
}

export function useLocales() {
  return useQuery({
    queryKey: qk.locales,
    queryFn: () => apiGet<LocaleEntry[]>('/reference/locales'),
    staleTime: 60 * 60_000,
  });
}

export function useTriggerEventTypes() {
  return useQuery({
    queryKey: qk.triggerTypes,
    queryFn: () => apiGet<TriggerEventType[]>('/reference/trigger-event-types'),
    staleTime: 60 * 60_000,
  });
}
